/* Нижнее поле колонки экрана создания (--ap-pad) под плавающую кнопку — как BotCore.foot шаблона (legacy/bot-core.js: pad, footNeed, padVal).
   Короткая форма не прокручивается (поле 0), длинная получает ровно столько, чтобы последний блок вставал над кнопкой и меню.
   Раньше серверные формы ставили постоянные 100 px: последний блок уходил под кнопку (на телефоне ей нужно 84 + 58 + 16), короткая форма прокручивалась. */
import { useLayoutEffect, type RefObject } from 'react';

const FOOT_GAP = 16;
const BUTTON = 58;

/** Колонка экрана: самая внешняя .ap-in (секция формы с тем же классом прокрутки не держит, native-template.css) */
function outerColumn(el: HTMLElement): HTMLElement | null {
  let col: HTMLElement | null = null;
  for (let p = el.parentElement; p; p = p.parentElement) if (p.classList.contains('ap-in')) col = p;
  return col;
}

export function useApPad(foot: RefObject<HTMLElement | null>, active = true) {
  useLayoutEffect(() => {
    const el = foot.current;
    const col = el && active ? outerColumn(el) : null;
    if (!el || !col) return;
    const bot = document.getElementById('bot');
    let raf = 0;
    const pad = () => {
      raf = 0;
      if (!col.isConnected || !el.isConnected) return;
      const mob = !!bot?.classList.contains('mob');
      const need = (mob ? 84 : 16) + BUTTON + FOOT_GAP;
      /* низ содержимого колонки без её нижнего поля: последний блок перед подвалом (или его контейнер) */
      const last = (el.previousElementSibling as HTMLElement | null) ?? el.parentElement;
      if (!last) return;
      const bottom = last.getBoundingClientRect().bottom - col.getBoundingClientRect().top + col.scrollTop;
      const value = bottom > col.clientHeight - need ? (mob ? `calc(${need}px + var(--sab,0px))` : `${need}px`) : '0px';
      if (col.style.getPropertyValue('--ap-pad') !== value) col.style.setProperty('--ap-pad', value);
    };
    const soon = () => {
      if (!raf) raf = requestAnimationFrame(pad);
    };
    pad();
    const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(soon);
    ro?.observe(col);
    if (el.parentElement) ro?.observe(el.parentElement);
    const mo = new MutationObserver(soon);
    mo.observe(col, { childList: true, subtree: true });
    return () => {
      cancelAnimationFrame(raf);
      ro?.disconnect();
      mo.disconnect();
      col.style.removeProperty('--ap-pad');
    };
  }, [foot, active]);
}
